<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label">
    <label class="mb-0">
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <input 
      class="field_submit" 
      value="" 
      [type]="showPassword ? 'text' : 'password'" 
      maxlength="200" 
      [formControlName]="fieldKey"
      (focus)="onInputFocus()"
    />
    <button
      *ngIf="showToggleButton"
      type="button"
      class="show-hide-pw-btn"
      (click)="togglePasswordVisibility()"
    >
      <mat-icon class="show-hide-pw-icon">
        {{ showPassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>
  </div>
</div>

<div *ngIf="field.format === 'password_with_confirmation'" class="field-wrapper confirmation"
  [formGroup]="formGroup">

  <!-- Confirm password field -->
  <div class="field-label">
    <label class="mb-0" style="font-weight: 500;">
      Confirm {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <input class="field_submit" [type]="showPassword ? 'text' : 'password'" [formControlName]="fieldKey + '_confirmation'" />
      <button
        *ngIf="showToggleButton"
        type="button"
        class="show-hide-pw-btn"
        (click)="togglePasswordVisibility()"
      >
        <mat-icon class="show-hide-pw-icon">
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </button>
  </div>
</div>